module.exports = __webpack_public_path__ + "static/media/ambassador-fitsum-arega.6bc7f833.png";